/**
 *
 * 高级检索结果页
 * 2017-12-04
 * Bai.Zhiming
 */
'use strict';
angular
    .module('seniorResultsSearchModule', [
        'resAdvancedSearchRouterModule', // 高级检索路由
    ])
    .controller('seniorResultsCtrl', [
        '$scope',
        'storageListenerService',
        '$state',
        'trsHttpService',
        '$stateParams',
        '$q',
        '$element',
        'resourceCenterService',
        function($scope, storageListenerService, $state, trsHttpService, $stateParams, $q, $element, resourceCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化数据
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    searchOpens: false, // 高级检索下拉框打开
                    clikedSearch: false, // 已点击搜索切换不同数据请求方式
                    sortStyle: false, // 升降序切换
                    contAllTerms: '', // 包含全部检索词-ng-model默认值
                    accurateTerms: '', // 精确检索词-ng-model默认值
                    leastOneTerms: '', // 包含一个最少检索值-ng-model默认值
                    notTerms: '', // 不包含一个检索词-ng-model默认值
                    manuscriptsId: '', // 稿件ID-ng-model默认值
                    author: '', // 作者-ng-model默认值
                    numMin: 0, // 字数小-ng-model默认值
                    numMax: '', // 字数大-ng-model默认值
                    accurateWords: '', // 包含精确关键词
                    accurateLabel: '', // 包含精确标签
                    tableTo: 0, // 切换渠道栏目
                    tableParams: '', // 渠道栏目当前选中类型
                    channelType: false, // 发布媒体-渠道类型
                    channelSection: false, // 发布媒体-渠道栏目
                    whetherJudge: false, // 判断是否要清楚媒体双全选的情况
                    areaAll: [], // 地域的级联数组
                    selectAll: [], // 渠道栏目全选所存数据
                    searchIcon: true, // 判断是否消失搜索图标
                    echoStr: false, // 是否回显
                    saveSort: 2, // 保存排序,判断是否切换排序
                };
                $scope.sequencingData = {
                    // 排序参数
                    data: [
                        {
                            name: '默认排序',
                            value: 0,
                        },
                        {
                            name: '按相关性',
                            value: 'RELEVANCE',
                        },
                        {
                            name: '按时间',
                            value: 'DOCPUBTIME',
                        },
                    ],
                    value: {
                        name: '默认排序',
                        value: 0,
                    },
                };
                $scope.paramsReturn = JSON.parse($stateParams.rightsData); // 高级检索页返回的检索数据
                $scope.tableData = []; // 列表数据
                $scope.ejectData = {
                    // 弹出框数据
                    positionData: {
                        // 位置信息
                        data: [
                            {
                                name: '位于任何位置',
                                value: 'full',
                            },
                            {
                                name: '位于文章标题',
                                value: 'title',
                            },
                            {
                                name: '位于文章正文',
                                value: 'context',
                            },
                        ],
                        value: {
                            // 位置信息值
                            name: '位于任何位置',
                            value: 'full',
                        },
                    },
                    postedMedia: {
                        // 发布媒体
                        data: [
                            {
                                name: '全部媒体',
                                value: '0',
                            },
                            {
                                name: '按渠道类型',
                                value: '1',
                            },
                            {
                                name: '按渠道栏目',
                                value: '2',
                            },
                        ],
                        value: {
                            // 位置信息值
                            name: '全部媒体',
                            value: 'full',
                        },
                        tableGet: [
                            // 渠道栏目标题
                            {
                                name: '新华社',
                                value: 'xhsg',
                            },
                            {
                                name: '数字报',
                                value: 'szb',
                            },
                            {
                                name: '网站',
                                value: 'wz',
                            },
                            {
                                name: '客户端',
                                value: 'app',
                            },
                            {
                                name: '微信',
                                value: 'wx',
                            },
                            {
                                name: '集团成品',
                                value: 'jtcpg',
                            },
                        ],
                        tableData: [
                            // 渠道栏目数据
                        ],
                    },
                    themeSearch: {
                        // 主题类型
                        data: [],
                        value: {
                            id: 'zyzxfield_000',
                            name: '全部',
                            dictNum: '000',
                            orderNum: '1',
                        },
                    },
                    selectShow: {
                        // 发布媒体显示对象切换
                        showMediaOne: false,
                        showMediaTwo: false,
                    },
                };
                $scope.timeData = {
                    // 时间参数
                };
                $scope.checkData = {
                    // 多选框可选择数
                    content: [
                        // 内容属性选框参数值
                        {
                            name: '只看原创',
                            value: 'original',
                        },
                        {
                            name: '只看头版（数字报）',
                            value: 'headline',
                        },
                        {
                            name: '只看10W+（微信）',
                            value: 'hot',
                        },
                    ],
                    include: [
                        // 包含内容属性选框值
                        {
                            name: '图片',
                            value: 'picture',
                        },
                        {
                            name: '音视频',
                            value: 'meidia',
                        },
                    ],
                    Channel: [
                        // 渠道类型选框值
                        {
                            name: '新华社',
                            value: 'all',
                            ditName: 'xhsg',
                        },
                        {
                            name: '网站',
                            value: 'all',
                            ditName: 'wz',
                        },
                        {
                            name: '微信',
                            value: 'all',
                            ditName: 'wx',
                        },
                        {
                            name: '数字报',
                            value: 'all',
                            ditName: 'szb',
                        },
                        {
                            name: '客户端',
                            value: 'all',
                            ditName: 'app',
                        },
                        {
                            name: '集团成品',
                            value: 'all',
                            ditName: 'jtcpg',
                        },
                    ],
                };
                $scope.selectCheck = {
                    // 多选框
                    contentAttr: [], // 内容属性选框
                    whetherNotCont: [], // 是否包含以下内容
                    channelTypeCheck: [], // 发布媒体-渠道类型选框
                    typeSmarquee: {
                        // 渠道类型选框各个类型
                        xhsg: [], // 新华社
                        szb: [], // 数字报
                        wz: [], // 网站
                        app: [], // 客户端
                        wx: [], // 微信
                        jtcpg: [], // 集团成品
                    },
                    marqueeSection: [], // 渠道栏目选框
                };
                $scope.page = {
                    // 分页
                    CURRPAGE: 1, // 页数
                    PAGESIZE: 10, // 数量
                };
                $scope.params = {
                    // 结果页必传参数
                    typeid: 'zyzx',
                    serviceid: 'iwo',
                    modelid: 'fullTableSearch',
                    pageNum: $scope.page.CURRPAGE, // 页数
                    pageSize: $scope.page.PAGESIZE, // 数量
                    order: '-DOCPUBTIME', // 默认按时间倒叙排序
                    keywords: {
                        search_relation: '0', // 暂保留字段
                        search_type: 'document', // 暂保留字段
                        search_range: 'full', // 出现检索词位置
                        content_attribute: [
                            {
                                original: '0',
                                headline: '0',
                                hot: '0',
                            },
                        ], // 内容属性
                        source_range: [
                            {
                                channelname: 'all',
                                sourcename: 'all',
                            },
                        ], // 发布媒体
                        contains: [
                            {
                                picture: '0',
                                meidia: '0',
                            },
                        ], // 是否包含以下内容
                    },
                };
                $scope.pageMedia = {
                    CURRPAGE: 1, // 页数
                    PAGESIZE: 20, // 数量//渠道栏目分页数据
                };
                $scope.paramsTwo = {
                    typeid: 'zyzx',
                    serviceid: 'iwo',
                    modelid: 'subscription',
                    channelName: 'xhsg',
                    pageNum: $scope.pageMedia.CURRPAGE,
                    pageSize: $scope.pageMedia.PAGESIZE, // 渠道栏目切换tab数据
                };
            }

            /**
             * [initData description] 初始化状态
             * @return {[type]} [description]
             */
            function initData() {
                themeData().then(function() {
                    if ($scope.paramsReturn.num == undefined && $scope.paramsReturn.num != 1) {
                        echo();
                        $scope.data.echoStr = true;
                    }
                });
                oneRequest();
            }

            /**
             * 回显，将高级搜索页前四个内容显示在高级结果页input上面和高级结果页的下拉框内
             */
            function echo() {
                var params = JSON.parse(angular.copy($stateParams.rightsData));
                if (params.keywords.time_range && params.keywords.time_range != 'undefined') {
                    params.keywords.time_range = decodeURIComponent(params.keywords.time_range);
                }
                var str = '';
                // 包含全部检索词
                if (params.keywords.keyword_spilt != undefined) {
                    str += params.keywords.keyword_spilt;
                    $scope.data.contAllTerms = params.keywords.keyword_spilt.split(' ');
                    // 包含精确检索词
                }
                if (params.keywords.keyword_and != undefined) {
                    $scope.data.accurateTerms = params.keywords.keyword_and.split(' ');
                    str += ' ' + '"' + params.keywords.keyword_and + '"';
                    // 包含至少一个检索词
                }
                if (params.keywords.keyword_or != undefined) {
                    $scope.data.leastOneTerms = params.keywords.keyword_or.split(' ');
                    str += ' (' + params.keywords.keyword_or + ')';
                    // 不包含检索词
                }
                if (params.keywords.keyword_not != undefined) {
                    $scope.data.notTerms = params.keywords.keyword_not.split(' ');
                    str += ' -(' + params.keywords.keyword_not + ')';
                }
                $scope.data.topInput = str;
                $scope.data.manuscriptsId = params.keywords.guid;
                $scope.data.author = params.keywords.author;
                if (params.keywords.exactkeywords != undefined) {
                    $scope.data.accurateWords = params.keywords.exactkeywords.split(' ');
                }
                if (params.keywords.exacttag != undefined) {
                    $scope.data.accurateLabel = params.keywords.exacttag.split(' ');
                }
                $scope.data.numMin = params.keywords.txs_rannge.split(';')[0];
                $scope.data.numMax = params.keywords.txs_rannge.split(';')[1];
                $scope.ejectData.positionData.value = getObjFromArr($scope.ejectData.positionData.data, 'value', params.keywords.search_range);
                $scope.selectCheck.contentAttr = [];
                for (var i = 0; i < $scope.checkData.content.length; i++) {
                    if (params.keywords.content_attribute[0][$scope.checkData.content[i].value] == 1) {
                        $scope.selectCheck.contentAttr.push($scope.checkData.content[i]);
                    }
                }
                for (var i = 0; i < $scope.ejectData.themeSearch.data.length; i++) {
                    if (params.keywords.topic == $scope.ejectData.themeSearch.data[i].id) {
                        $scope.ejectData.themeSearch.value = $scope.ejectData.themeSearch.data[i];
                    }
                }
                for (var i = 0; i < $scope.checkData.include.length; i++) {
                    if (params.keywords.contains[0][$scope.checkData.include[i].value] == 1) {
                        $scope.selectCheck.whetherNotCont.push($scope.checkData.include[i]);
                    }
                }
                if (params.keywords && params.keywords.time_range != 'undefined') {
                    $scope.timeData.fromdate = params.keywords.time_range.split(';')[0];
                    $scope.timeData.untildate = params.keywords.time_range.split(';')[1];
                }
                if (params.keywords.area != undefined) {
                    $scope.data.areaAll = params.areaAll;
                }
                $scope.selectCheck.channelTypeCheck = [];
                if (params.showMedia == 0) {
                    $scope.ejectData.postedMedia.value = $scope.ejectData.postedMedia.data[0];
                } else if (params.showMedia == 1) {
                    $scope.ejectData.postedMedia.value = $scope.ejectData.postedMedia.data[1];
                    $scope.data.channelType = true;
                    for (var i = 0; i < params.keywords.source_range.length; i++) {
                        for (var j = 0; j < $scope.checkData.Channel.length; j++) {
                            if (params.keywords.source_range[i].sourcename == $scope.checkData.Channel[j].ditName) {
                                $scope.selectCheck.channelTypeCheck.push($scope.checkData.Channel[j]);
                            }
                        }
                    }
                } else {
                    $scope.ejectData.postedMedia.value = $scope.ejectData.postedMedia.data[2];
                    $scope.data.selectAll = params.selection;
                    $scope.selectCheck.marqueeSection = params.marqueeSection;
                    $scope.data.channelSection = true;
                }
            }

            /**
             * [getObjFromArr description]
             * @param   {[type]}  arr       [arr description]
             * @param   {[type]}  property  [property description]
             * @param   {[type]}  value     [value description]
             * @return  {[type]}            [return description]
             */
            function getObjFromArr(arr, property, value) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i][property] == value) {
                        return arr[i];
                    }
                }
                return false;
            }

            /**
             * [showSearch description] 显示高级检索下拉框
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            $scope.showSearch = function(key) {
                $scope.data.searchOpens = !key;
            };

            /**
             * [stop description] 转载媒体阻止冒泡
             * @param  {[type]} e [description]
             * @return {[type]}   [description]
             */
            $scope.stop = function(e) {
                e.stopPropagation();
            };

            /**
             * [retrieveData description] 点击检索按钮
             * @return {[type]} [description]
             */
            $scope.retrieveData = function() {
                $scope.data.searchOpens = false; // 关闭下拉框
                $scope.data.clikedSearch = true; // 更改数据状态-结果页搜索后的结果
                requestData();
            };

            /**
             * [sortData description] 切换升降排序
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            $scope.sortData = function(key) {
                // 排序点击一样的可切换
                if (key == $scope.data.saveSort) {
                    key == 1 ? (key = 2) : (key = 1);
                }
                $scope.data.saveSort = key;
                // 升序1降序2
                key == 1 ? ($scope.data.sortStyle = true) : ($scope.data.sortStyle = false); // 更改升降序样式
                if (!$scope.data.clikedSearch) {
                    // 高级检索页返回数据
                    if ($scope.paramsReturn.val != undefined) {
                        // 处理人物排行跳转排序无效的问题
                        $scope.paramsReturn = angular.copy($scope.params);
                        $scope.paramsReturn.keywords.keyword_and = $scope.data.topInput;
                    }
                    var order = $scope.paramsReturn.order.substring(1);
                    key == 1 ? ($scope.paramsReturn.order = '+' + order) : ($scope.paramsReturn.order = '-' + order);
                    oneRequest();
                } else {
                    // 结果页搜索返回数据
                    var order = $scope.params.order.substring(1);
                    key == 1 ? ($scope.params.order = '+' + order) : ($scope.params.order = '-' + order);
                    requestData();
                }
            };

            /**
             * [selectSwitch description] 排序选择切换
             * @param   {[type]}  value  [value description]
             * @param   {[type]}  key    [key description]
             * @return  {[type]}         [return description]
             */
            $scope.selectSwitch = function(value, key) {
                if (!$scope.data.clikedSearch) {
                    if ($scope.paramsReturn.num != undefined) {
                        $scope.params.order = value.value == 'RELEVANCE' ? '-RELEVANCE' : '-DOCPUBTIME';
                    } else {
                        value.value == 'RELEVANCE' ? ($scope.paramsReturn.order = '-RELEVANCE') : ($scope.paramsReturn.order = '-DOCPUBTIME');
                    }
                    oneRequest();
                } else {
                    value.value == 'RELEVANCE' ? ($scope.params.order = '-RELEVANCE') : ($scope.params.order = '-DOCPUBTIME');
                    requestData();
                }
                $scope.data.sortStyle = false;
            };

            /**
             * [selectItem description] 多选框选择
             * @param   {[type]}  item  [item description]
             * @param   {[type]}  key   [key description]
             * @param   {[type]}  dif   [dif description]
             * @return  {[type]}        [return description]
             */
            $scope.selectItem = function(item, key, dif) {
                var index = key.indexOf(item);
                if (index >= 0) {
                    key.splice(index, 1);
                    if (dif == 1) {
                        // 内容属性
                        $scope.params.keywords.content_attribute[0][item.value] = '0';
                    } else if (dif == 2) {
                        // 是否包含以下内容
                        $scope.params.keywords.contains[0][item.value] = '0';
                    }
                } else {
                    key.push(item);
                    if (dif == 1) {
                        // 内容属性
                        $scope.params.keywords.content_attribute[0][item.value] = '1';
                    } else if (dif == 2) {
                        // 是否包含以下内容
                        $scope.params.keywords.contains[0][item.value] = '1';
                    }
                }
            };

            /**
             * [dropDownBox description]
             * @param   {[type]}  key    [key description]
             * @param   {[type]}  value  [value description]
             * @return  {[type]}         [return description]
             */
            $scope.dropDownBox = function(key, value) {
                switch (key) {
                    case 1: // 包含全部检索词
                        $scope.params.keywords.search_range = value.value;
                        break;
                    case 2: // 发布媒体
                        if (value.value == 0) {
                            // 全部
                            $scope.params.keywords.source_range = [
                                {
                                    channelname: 'all',
                                    sourcename: 'all',
                                },
                            ];
                            $scope.data.channelSection = $scope.data.channelType = false;
                        } else if (value.value == 1) {
                            // 渠道类型
                            $scope.data.channelType = true;
                            $scope.data.channelSection = false;
                        } else {
                            // 渠道栏目
                            $scope.data.channelType = false;
                            $scope.data.channelSection = true;
                            $scope.tabPageSwitch(0, 'xhsg');
                            // $scope.typeSmarquee
                        }
                        break;
                    case 3: // 文章所属主题
                        value.dictNum == '000' ? delete $scope.params.keywords.topic : ($scope.params.keywords.topic = value.id);
                        break;
                }
            };

            /**
             * [getTimeDate description] 选择时间
             * @return {[type]} [description]
             */
            $scope.getTimeDate = function() {
                var et = $scope.timeData.fromdate.replace(new RegExp('-', 'gm'), '/');
                var st = $scope.timeData.untildate.replace(new RegExp('-', 'gm'), '/');
                regTrue(et) ? ($scope.params.keywords.time_range = et + ';' + st) : delete $scope.params.keywords.time_range;
            };

            /**
             * [tabPageSwitch description] 发布媒体-渠道栏目切换
             * @param   {[type]}  key    [key description]
             * @param   {[type]}  value  [value description]
             * @return  {[type]}         [return description]
             */
            $scope.tabPageSwitch = function(key, value) {
                $scope.data.tableTo = key; // 切换tab样式下边框
                if ($scope.paramsTwo.channelName != value) {
                    $scope.paramsTwo.pageNum = 1;
                    $scope.pageMedia.CURRPAGE = 1;
                }
                $scope.paramsTwo.channelName = value; //
                $scope.data.tableParams = value;
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.paramsTwo, 'post').then(function(data) {
                    // 总数据
                    $scope.ejectData.postedMedia.tableData = data.content;
                    $scope.pageMedia.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    // 比较已选确认勾起来
                    if ($scope.data.selectAll.length > 0) {
                        for (var i in $scope.data.selectAll) {
                            // 已选
                            for (var j in $scope.ejectData.postedMedia.tableData) {
                                // 新刷数据
                                if ($scope.data.selectAll[i].HYBASEID == $scope.ejectData.postedMedia.tableData[j].HYBASEID) {
                                    $scope.selectCheck.marqueeSection.push($scope.ejectData.postedMedia.tableData[j]);
                                }
                            }
                        }
                    }
                });
            };

            /**
             * [searchColumn description] 渠道栏目搜索
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            $scope.searchColumn = function(key) {
                regTrue(key) ? ($scope.paramsTwo.keyword = key) : delete $scope.paramsTwo.keyword;
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.paramsTwo, 'post').then(function(data) {
                    // 总数据
                    $scope.ejectData.postedMedia.tableData = data.content;
                    $scope.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                });
            };

            /**
             * [mediaSelect description] 发布媒体专用选框
             * @param   {[type]}  item  [item description]
             * @param   {[type]}  key   [key description]
             * @param   {[type]}  dif   [dif description]
             * @return  {[type]}        [return description]
             */
            $scope.mediaSelect = function(item, key, dif) {
                var index = key.indexOf(item);
                if (index >= 0) {
                    // 取消勾选 selectAll
                    key.splice(index, 1);
                    if (dif == 2) {
                        // 渠道栏目
                        var lu = $scope.selectCheck.typeSmarquee[item.SECTION].indexOf(item);
                        lu != -1 && $scope.selectCheck.typeSmarquee[item.SECTION].splice(lu, 1);
                        $scope.data.selectAll.indexOf(item) != -1 && $scope.data.selectAll.splice($scope.data.selectAll.indexOf(item), 1);
                    }
                } else {
                    // 添加勾选
                    key.push(item);
                    if (dif == 2) {
                        // 对应渠道栏目
                        $scope.selectCheck.typeSmarquee[item.SECTION].push(item);
                        $scope.data.selectAll.push(item); // 已选择
                    }
                }
            };

            /**
             * [sweat description] 删除对应
             * @param   {[type]}  key  [key description]
             * @return  {[type]}       [return description]
             */
            $scope.sweat = function(key) {
                // e.stopPropagation();
                for (var i in $scope.data.selectAll) {
                    if ($scope.data.selectAll[i].HYBASEID == key.HYBASEID) {
                        $scope.data.selectAll.splice(i, 1);
                    }
                }
                for (var k in $scope.selectCheck.marqueeSection) {
                    if ($scope.selectCheck.marqueeSection[k].HYBASEID == key.HYBASEID) {
                        $scope.selectCheck.marqueeSection.splice(k, 1);
                    }
                }
            };

            /**
             * [showSelectedArea description] 地域选中
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
            $scope.showSelectedArea = function(node) {
                var deffer = $q.defer();
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'navigation',
                    modelid: 'getArea',
                };
                if (node.id == undefined) {
                    params.parent_id = '-1';
                } else {
                    params.parent_id = node.id;
                }
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    if (data.length > 2) {
                        deffer.resolve(data);
                    } else {
                        deffer.resolve(data[0].CHILDREN);
                    }
                });
                return deffer.promise;
            };

            /**
             * [searchWithArea description] 根据地域信息筛选稿件
             * @return {[type]} [description]
             */
            $scope.searchWithArea = function() {
                $scope.params.keywords.area = $scope.data.areaAll[0][$scope.data.areaAll[0].length - 1].id;
            };

            /**
             * [selectPageNum description] 切换数量
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                // 切换数据
                if (!$scope.data.clikedSearch) {
                    // 高级检索页搜索页分页
                    $scope.paramsReturn.pageSize = $scope.page.PAGESIZE;
                    $scope.paramsReturn.pageNum = 1;
                    oneRequest();
                } else {
                    // 结果页
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.params.pageNum = 1;
                    requestData();
                }
            };

            /**
             * [pageChanged description]分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                // 切换数据是
                if (!$scope.data.clikedSearch) {
                    // 高级检索页搜索页分页
                    $scope.paramsReturn.pageNum = $scope.page.CURRPAGE;
                    oneRequest();
                } else if ($scope.data.clikedSearch) {
                    // 结果页
                    $scope.params.pageNum = $scope.page.CURRPAGE;
                    requestData();
                }
                $element.children('.seniorResultsPage').scrollTop(0);
            };

            /**
             * [pageChangedCopy description] 渠道栏目分页
             * @return {[type]} [description]
             */
            $scope.pageChangedCopy = function() {
                $scope.paramsTwo.pageNum = $scope.pageMedia.CURRPAGE;
                $scope.tabPageSwitch($scope.data.tableTo, $scope.data.tableParams);
            };

            /**
             * [regTrue description] 检查非空
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            function regTrue(value) {
                return /\S/.test(value);
            }

            /**
             * [arrayToString description] 数组转为字符串
             * @param   {[type]}  array     [array description]
             * @param   {[type]}  property  [property description]
             * @return  {[type]}            [return description]
             */
            function arrayToString(array, property) {
                if (array.length > 0) {
                    var stringArray = [];
                    for (var i = 0; i < array.length; i++) {
                        stringArray.push(array[i][property]);
                    }
                    return stringArray.join(' ');
                }
            }

            /**
             *
             * [paramsJudgment description] 判断是否传递该参数
             * @return {[type]} [description]
             */
            function paramsJudgment() {
                // 包含全部检索词
                $scope.data.contAllTerms.length > 0
                    ? ($scope.params.keywords.keyword_spilt = arrayToString($scope.data.contAllTerms, 'name'))
                    : delete $scope.params.keywords.keyword_spilt;
                // regTrue($scope.data.contAllTerms) ? $scope.params.keywords.keyword_spilt = $scope.data.contAllTerms : delete $scope.params.keywords.keyword_spilt;
                // 包含精确检索词
                $scope.data.accurateTerms.length > 0
                    ? ($scope.params.keywords.keyword_and = arrayToString($scope.data.accurateTerms, 'name'))
                    : delete $scope.params.keywords.keyword_and;
                // regTrue($scope.data.accurateTerms) ? $scope.params.keywords.keyword_and = $scope.data.accurateTerms : delete $scope.params.keywords.keyword_and;
                // 包含至少一个检索词
                $scope.data.leastOneTerms.length > 0
                    ? ($scope.params.keywords.keyword_or = arrayToString($scope.data.leastOneTerms, 'name'))
                    : delete $scope.params.keywords.keyword_or;
                // regTrue($scope.data.leastOneTerms) ? $scope.params.keywords.keyword_or = $scope.data.leastOneTerms : delete $scope.params.keywords.keyword_or;
                // 不包含检索词
                $scope.data.notTerms.length > 0
                    ? ($scope.params.keywords.keyword_not = arrayToString($scope.data.notTerms, 'name'))
                    : delete $scope.params.keywords.keyword_not;
                // regTrue($scope.data.notTerms) ? $scope.params.keywords.keyword_not = $scope.data.notTerms : delete $scope.params.keywords.keyword_not;
                // 稿件ID
                regTrue($scope.data.manuscriptsId) ? ($scope.params.keywords.guid = $scope.data.manuscriptsId) : delete $scope.params.keywords.guid;
                // 作者
                regTrue($scope.data.author) ? ($scope.params.keywords.author = $scope.data.author) : delete $scope.params.keywords.author;
                // 字数
                !regTrue($scope.data.numMin) && !regTrue($scope.data.numMax)
                    ? delete $scope.params.keywords.txs_rannge
                    : ($scope.params.keywords.txs_rannge =
                          (regTrue($scope.data.numMin) ? $scope.data.numMin : '*') + ';' + (regTrue($scope.data.numMax) ? $scope.data.numMax : '*'));
                // 包含精确关键词
                $scope.data.accurateWords.length > 0
                    ? ($scope.params.keywords.exactkeywords = arrayToString($scope.data.accurateWords, 'name'))
                    : delete $scope.params.keywords.exactkeywords;
                // regTrue($scope.data.accurateWords) ? $scope.params.keywords.exactkeywords = $scope.data.accurateWords : delete $scope.params.keywords.exactkeywords;
                // 包含精确标签
                $scope.data.accurateLabel.length > 0
                    ? ($scope.params.keywords.exacttag = arrayToString($scope.data.accurateLabel, 'name'))
                    : delete $scope.params.keywords.exacttag;
                // regTrue($scope.data.accurateLabel) ? $scope.params.keywords.exacttag = $scope.data.accurateLabel : delete $scope.params.keywords.exacttag;

                $scope.data.areaAll != undefined ? ($scope.params.areaAll = $scope.data.areaAll) : ($scope.params.areaAll = []);
                if ($scope.data.channelType) {
                    $scope.params.showMedia = 1;
                    // $scope.params.selectChannel = $scope.selectCheck.channelTypeCheck;
                } else if ($scope.data.channelSection) {
                    $scope.params.showMedia = 2;
                    $scope.params.selection = $scope.data.selectAll;
                    $scope.params.marqueeSection = $scope.selectCheck.marqueeSection;
                } else {
                    $scope.params.showMedia = 0;
                }

                // 判断渠道类型和渠道栏目
                // 初始化
                $scope.params.keywords.source_range = [
                    {
                        channelname: 'all',
                        sourcename: 'all',
                    },
                ];
                var addType = [];
                var typeSmarqueeCopy = angular.copy($scope.selectCheck.typeSmarquee);
                // 抽离类型集合(有勾选)保存在addType做渠道栏目去除
                if ($scope.selectCheck.channelTypeCheck.length > 0) {
                    $scope.data.whetherJudge = true;
                    for (var i in $scope.selectCheck.channelTypeCheck) {
                        $scope.params.keywords.source_range.push({
                            channelname: 'all',
                            sourcename: $scope.selectCheck.channelTypeCheck[i].ditName,
                        });
                        // 删除类型已有的勾选
                        delete typeSmarqueeCopy[$scope.selectCheck.channelTypeCheck[i].ditName];
                    }
                    // 操作渠道栏目有选的
                    for (var j in typeSmarqueeCopy) {
                        // CHANNELNAME=app HYBASEID="ranknature_002"
                        if (typeSmarqueeCopy[j].length > 0) {
                            // 有勾选的拿过来处理
                            var takeOne = '';
                            for (var k in typeSmarqueeCopy[j]) {
                                // 取出
                                takeOne += typeSmarqueeCopy[j][k].HYBASEID + ',';
                                if (k == typeSmarqueeCopy[j].length - 1) {
                                    takeOne = takeOne.substring(0, takeOne.length - 1);
                                    $scope.params.keywords.source_range.push({
                                        channelname: takeOne,
                                        sourcename: typeSmarqueeCopy[j][k].SECTION,
                                    });
                                }
                            }
                        }
                    }
                } else if ($scope.selectCheck.channelTypeCheck.length == 0) {
                    // 类型无勾选
                    var takeTwo = '';
                    for (var i in $scope.selectCheck.typeSmarquee) {
                        if ($scope.selectCheck.typeSmarquee[i].length > 0) {
                            $scope.data.whetherJudge = true;
                            for (var j in $scope.selectCheck.typeSmarquee[i]) {
                                takeTwo += typeSmarqueeCopy[i][j].HYBASEID + ',';
                                if (j == typeSmarqueeCopy[i].length - 1) {
                                    takeTwo = takeTwo.substring(0, takeTwo.length - 1);
                                    $scope.params.keywords.source_range.push({
                                        channelname: takeTwo,
                                        sourcename: typeSmarqueeCopy[i][j].SECTION,
                                    });
                                }
                            }
                        }
                    }
                }
                $scope.data.whetherJudge == true && $scope.params.keywords.source_range.splice(0, 1);
            }

            /**
             * [requesData description] 高级检索页返回回来的数据请求table数据
             * @return {[type]} [description]
             */
            function oneRequest() {
                // 人物排行-跳转过来做判断-下次再搜索依照原有高级检索规则
                if ($scope.paramsReturn.num != undefined && $scope.paramsReturn.num === 1) {
                    $scope.data.topInput = $scope.paramsReturn.val;
                    var params = angular.copy($scope.params);
                    params.keywords.keyword_spilt = $scope.paramsReturn.val;
                    params.keywords.txs_rannge = '0;*';
                    $scope.data.contAllTerms = params.keywords.keyword_spilt.split(' ');
                    $scope.paramsReturn.num++;
                } else {
                    if ($scope.paramsReturn.num != undefined) {
                        var params = angular.copy($scope.params);
                        // params.keywords.keyword_and = $scope.data.topInput.match(/\"(.*)\"/g)[0].replace(/\"/g,'');
                    } else {
                        var params = angular.copy($scope.paramsReturn);
                        if (params.keywords.time_range && params.keywords.time_range != 'undefined') {
                            params.keywords.time_range = decodeURIComponent(params.keywords.time_range); // 对URL的组成部分进行个别编码，而不用于对整个URL进行编码
                        }

                        // params.keywords.keyword_and = $scope.data.topInput.match(/\"(.*)\"/g)[0].replace(/\"/g,'');
                    }
                    params.pageSize = $scope.page.PAGESIZE;
                    params.pageNum = $scope.page.CURRPAGE;
                }
                paramsJudgment();
                params.keywords = JSON.stringify(params.keywords);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    for (var i = 0; i < data.content.length; i++) {
                        if (typeof data.content[i].ZB_KEYWORDS5 === 'string') {
                            data.content[i].ZB_KEYWORDS5 = data.content[i].ZB_KEYWORDS5.split(';');
                        }
                        data.content[i].DOCAUTHOR = data.content[i].DOCAUTHOR == null ? '' : data.content[i].DOCAUTHOR;
                        data.content[i].ZB_SOURCE_SITE = data.content[i].ZB_SOURCE_SITE == null ? '' : data.content[i].ZB_SOURCE_SITE;
                    }
                    $scope.tableData = data.content;
                    // for(var i in tableData){//循环这个button里面的字段

                    // }
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    data.content.map(function(x) {
                        x.ZB_GUID = x.ZB_GUID_CHAR;
                    });
                    storageListenerService.relatedPageTurningStorage(
                        data.content,
                        'ZB_GUID,DATABASENAME,DOC_TYPE',
                        'relatedDetail',
                        'ZB_GUID,indexname,channel'
                    );
                });
            }

            /**
             * [requestData description] 结果页请求
             * @param   {[type]}  str  [str description]
             * @return  {[type]}       [return description]
             */
            function requestData(str) {
                paramsJudgment();
                var params = angular.copy($scope.params);
                params.keywords = JSON.stringify(params.keywords);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    data.content = angular.isArray(data.content) ? data.content : [];
                    for (var i = 0; i < data.content.length; i++) {
                        if (typeof data.content[i].ZB_KEYWORDS5 === 'string') {
                            data.content[i].ZB_KEYWORDS5 = data.content[i].ZB_KEYWORDS5.split(';');
                        }
                        data.content[i].DOCAUTHOR = data.content[i].DOCAUTHOR == null ? '' : data.content[i].DOCAUTHOR;
                        data.content[i].ZB_SOURCE_SITE = data.content[i].ZB_SOURCE_SITE == null ? '' : data.content[i].ZB_SOURCE_SITE;
                    }

                    $scope.tableData = data.content;
                    data.content.map(function(x) {
                        x.ZB_GUID = x.ZB_GUID_CHAR;
                    });
                    storageListenerService.relatedPageTurningStorage(
                        data.content,
                        'ZB_GUID,DATABASENAME,DOC_TYPE',
                        'relatedDetail',
                        'ZB_GUID,indexname,channel'
                    );
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                });
            }

            /**
             * [modiaData description] 主题数据请求
             * @return {[type]} [description]
             */
            function themeData() {
                var defer = $q.defer();
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'subscript',
                    modelid: 'getAllFields',
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    for (var i in data) {
                        data[i].name = data[i].dictName;
                        delete data[i].dictName;
                    }
                    data.unshift($scope.ejectData.themeSearch.value);
                    $scope.ejectData.themeSearch.data = $scope.ejectData.themeSearch.data.concat(data);
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getSearch description] 点击搜索
             * @return {[type]} [description]
             */
            $scope.getSearch = function() {
                if (!$scope.data.searchOpens && !$scope.data.echoStr) {
                    // 高级检索没有打开
                    $scope.page.CURRPAGE = 1;
                    oneToFour($scope.data.topInput);
                    requestData();
                } else {
                    // 高级检索打开
                    paramsJudgment();
                    var params = angular.copy($scope.params);
                    $state.go('seniorResults', { rightsData: JSON.stringify(params) });
                }
            };

            /**
             * [oneToFour description] 逆向 input数据拆分成4个input 数据
             * @param  {[type]} text [description] input 数据
             * @return {[type]}      [description]
             */
            function oneToFour(text) {
                $scope.data.contAllTerms = [];
                $scope.data.accurateTerms = [];
                $scope.data.leastOneTerms = [];
                $scope.data.notTerms = [];
                if (text == undefined) {
                    return;
                } else {
                    // 不包含检索词
                    var rx_four = /-\(([\S\s]*?)\)/g;
                    var array_four = text.match(rx_four);
                    if (!!array_four) {
                        for (var i = 0; i < array_four.length; i++) {
                            text = text.replace(array_four[i], '');
                            array_four[i] = array_four[i].replace('-(', '').replace(')', '');
                            var subArr_four = array_four[i].split(' ');
                            if (subArr_four.length > 1) {
                                for (var j = 0; j < subArr_four.length; j++) {
                                    $scope.data.notTerms.push({
                                        name: subArr_four[j],
                                    });
                                }
                            } else {
                                $scope.data.notTerms.push({
                                    name: array_four[i],
                                });
                            }
                        }
                    }
                    // 包含一个至少检索词
                    var rx_three = /\(([\S\s]*?)\)/g;
                    var array_three = text.match(rx_three);
                    if (!!array_three) {
                        for (var i = 0; i < array_three.length; i++) {
                            text = text.replace(array_three[i], '');
                            array_three[i] = array_three[i].replace('(', '').replace(')', '');
                            var subArr_three = array_three[i].split(' ');
                            if (subArr_three.length > 1) {
                                for (var j = 0; j < subArr_three.length; j++) {
                                    $scope.data.leastOneTerms.push({
                                        name: subArr_three[j],
                                    });
                                }
                            } else {
                                $scope.data.leastOneTerms.push({
                                    name: array_three[i],
                                });
                            }
                        }
                    }
                    // 包含精确检索词
                    var rx_two = /\"([\S\s]*?)\"/g;
                    var array_two = text.match(rx_two);
                    if (!!array_two) {
                        for (var i = 0; i < array_two.length; i++) {
                            text = text.replace(array_two[i], '');
                            array_two[i] = array_two[i].replace('(', '').replace(')', '');
                            var subArr_two = JSON.parse(array_two[i]).split(' ');
                            if (subArr_two.length > 1) {
                                for (var j = 0; j < subArr_two.length; j++) {
                                    $scope.data.accurateTerms.push({
                                        name: subArr_two[j],
                                    });
                                }
                            } else {
                                $scope.data.accurateTerms.push({
                                    name: JSON.parse(array_two[i]),
                                });
                            }
                        }
                    }
                    // 包含全部检索词
                    text = text.replace(/[ ]+/g, ' ');
                    var array_one = text.split(' ');
                    if (!!array_one) {
                        for (var i = 0; i < array_one.length; i++) {
                            if (!array_one[i]) {
                                continue;
                            }
                            $scope.data.contAllTerms.push({
                                name: array_one[i],
                            });
                        }
                    }
                }
            }

            /**
             * [jumpdetailPage description] 跳转稿件详情页
             * @param   {[type]}  parameter  [parameter description]
             * @return  {[type]}             [return description]
             */
            $scope.jumpdetailPage = function(parameter) {
                // 集团成品和分类资源：resourcedetail（参数guid、channel、indexname）
                // 新华社稿：resourcexhsgbigdatadetail（参数guid、indexname）
                if (parameter.ZB_TYPE == 'xhsg') {
                    var url = $state.href('resourcexhsgbigdatadetail', {
                        guid: parameter.ZB_GUID_CHAR,
                        indexname: parameter.DATABASENAME,
                        relateddetail: 2,
                    });
                    window.open(url);
                    // window.open(url + "?guid=" + parameter.ZB_GUID_CHAR + '&indexname=' + parameter.DATABASENAME);
                } else {
                    var url = $state.href('resourcedetail', {
                        guid: parameter.ZB_GUID_CHAR,
                        indexname: parameter.DATABASENAME,
                        channel: parameter.ZB_TYPE,
                        relateddetail: 2,
                    });
                    window.open(url);
                    // window.open(url + "?guid=" + parameter.ZB_GUID_CHAR + '&indexname=' + parameter.DATABASENAME + '&channel=' + parameter.DOC_TYPE);
                }
            };
        },
    ]);
